@if (showSpinner) {
  <app-loader> </app-loader>
}
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  <div class="container-fluid mb-4">
    <div class="attendance-time-section">
      <div class="row">
        <div class="col-sm-6 col-md-4 col-xl-2 timer">
          <div class="timer-inner my-2" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <h1>Available Leaves</h1>
            <!-- <h1>{{ 21 - paidLeaves }}</h1> -->
            <div class="total-leaves-section">

              <h1>{{total_leaves - paidLeaves}}</h1>
              <div class="info-button" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }" data-toggle="modal"
                data-target="#leaveinfoModal" (click)="remainingLeaves()">
                <i class="fa fa-info-circle"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 col-xl-2 timer">
          <div class="timer-inner my-2 text-center" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <h1>Approved Paid Leaves</h1>
            <h1>{{ paidLeaves }}</h1>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 col-xl-2 timer">
          <div class="timer-inner my-2" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <h1>Rejected Leaves</h1>
            <h1>{{ rejectedLeaves }}</h1>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 col-xl-2 timer">
          <div class="timer-inner my-2" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <h1>Renew Date</h1>
            <h1>1st Sep {{ renewalYear }}</h1>
          </div>
        </div>

        <div class="col-sm-6 col-md-4 col-xl-2 offset-xl-2 timer"
          [routerLink]="['/apply-leaves', paidLeaves, rejectedLeaves]">
          <div class="timer-inner my-2" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <img src="../../../assets/images/apply-leave-icon.svg" alt="" />
            <h1>Apply Leave</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="attendance-report-table mt-3">

      <div class="attendance-report-table-header d-flex justify-content-around">
        <div class="table-heading text-center">Leave Title</div>
        <div class="table-heading text-center">Leave Number</div>
        <div class="table-heading text-center">Leave Date</div>
        <div class="table-heading text-center">Applied Date</div>
        <div class="table-heading text-center">Leave Type</div>
        <!-- <div class="table-heading text-center">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Status</div> -->
        <!-- <div class="table-heading text-center">Action</div> -->
      </div>

      @for (type of typeArr; track type) {
        <div class="attendance-report-table-body d-flex justify-content-around  my-4 my-md-0 "
          [ngClass]="{ 'dark-backround': selectedMode === 'dark' }"
          style="background:{{ type.backgroundColor }} ;">
          <div class="innerAbove d-flex ">
            <div class="table-cotent">
              <div class="table-content-value text-md-center" id="checkin-value">
                <h1 style="color:{{ type.titleColor }} ;">{{ type.title }}</h1>
              </div>
            </div>
            <div class="table-cotent">
              <div class="table-content-value text-center">
                @if (type.leave_type_id == 2) {
                  <h1>
                    {{ calculateDiff(type.start_date, type.end_date) }}
                  </h1>
                }
                @if (type.leave_type_id == 3) {
                  <h1>0.5</h1>
                }
              </div>
            </div>
            <div class="table-cotent">
              <div class="table-content-value text-md-center" id="checkout-value">
                @if (checkFull(type.end_date)) {
                  <h1 style="color:{{ titleColor }} ;">
                    {{ type.start_date | date : "dd MMM" }} to
                    {{ type.end_date | date : "dd MMM" }}
                  </h1>
                }
                @if (checkShort(type.end_date)) {
                  <h1 style="color:{{ titleColor }} ;">
                    {{ type.start_date | date : "dd MMM" }} ({{
                    getShift(type.short_leave)
                    }})
                  </h1>
                }
              </div>
            </div>
            <div class="table-cotent">
              <div class="table-content-value text-md-center">
                <h1 style="color:{{ type.titleColor }} ;">
                  {{ type.applied_date }}
                </h1>
              </div>
            </div>
            <div class="table-cotent">
              <div class="table-content-value text-md-center">
                <h1 style="color:{{ type.titleColor }} ;">
                  {{ type.leave_name |titlecase }}<span class="leave_name_type">({{type.leave_payment_status |
                titlecase}})</span>
              </h1>
            </div>
          </div>
        </div>
        <!-- <div class="inderBelow d-flex mt-3 pt-2" ngIf="type.leave_version == 1">
        <div class="table-heading text-center pt-2 "><strong>Reason:</strong></div>
        <div class="table-content-value description-box text-md-left pt-2 " id="checkin-value">
          <h1 style="color:{{ type.titleColor }} ;">
            {{ type.description }}
          </h1>
        </div>
      </div> -->
      <!-- <div class="inderBelow d-flex mt-3 pt-2" >
      <div class="table-heading text-center pt-2 "><strong>Status:</strong></div>
      <div class="table-cotent ">
        <div class="table-content-value text-md-center btnHandle ">
            <h1 *ngIf="checkFull(type.end_date)" class=" status-leave3 " style="background-color: {{
                getLeaveColor(type.status)
              }};text-transform: capitalize;border: 1px solid {{
                type.bdrColor
              }};color:{{ type.statusColor }} !important; font-size: 12px;">
            {{ type.status }}
          </h1>
            <h1 *ngIf="checkShort(type.end_date)" class="status-leave3 " style="background-color: {{
                getLeaveColor(type.status)
              }};text-transform: capitalize; font-size: 12px;">
            {{ type.status }}
          </h1>
            <h1 *ngIf="isPaid(type.leave_payment_status)" class="status-leave3 " style="
                background-color: #bcffc3;
                text-transform: capitalize;
                border: 1px solid #71d97b;
                color: #03670d !important;
                font-size: 12px;
              ">
            {{ type.leave_payment_status }}
          </h1>
            <h1 *ngIf="isUnPaid(type.leave_payment_status)" class="status-leave3 " style="
                background-color: #ffedc0;
                text-transform: capitalize;
                border: 1px solid #ffb700;
                color: #ffb700 !important;
                font-size: 12px;
              ">
            {{ type.leave_payment_status }}
          </h1>
        </div>
      </div>
    </div> -->
    <!-- <div class="inderBelow d-flex mt-2" *ngIf="type?.status=='rejected'">
    <div class="table-heading text-center pt-2 w-40"><strong>Rejected Reason:</strong></div>
    <div class="table-content-value description-box text-md-left pt-2 " id="checkin-value">
      <h1 style="color:{{ type.titleColor }} ;">
        {{ type.rejected_reason }}
      </h1>
    </div>
  </div> -->
  <!-- new design -->
  <div class="leave-reason">
    <div class="reason-heading">
      Reason:
    </div>
    <div class="reason-descrption">
      <h1 style="color:{{ type.titleColor }} ;">
        {{ type.description }}
      </h1>
    </div>
  </div>
  <!-- <div class="leave-reason rejected-reason" *ngIf="type?.status=='rejected' && type?.leave_version == null">
  <div class="reason-heading">
    Rejected Reason:
  </div>
  <div class="reason-descrption">
    <h1 style="color:{{ type.titleColor }} ;">
      {{ type.rejected_reason }}
    </h1>
  </div>
</div> -->
<div class="leave-reason">
  <div class="reason-heading">
    Status:
  </div>
  <div class="reason-descrption status-section">
    <div class="admin-detail-wrapper-main">
      @if (((type.status === 'pending' && isPendingstatus(type)) || !isAdmindata(type))) {
        <div class="admin-section"
          >
          <div class="admin-image">
            <img [src]="'assets/images/question.jpg'" alt="missing">
          </div>
          <div class="admin-detail">
            <h1></h1>
            <h6>Pendding</h6>
          </div>
        </div>
      }
      <div class="main-admin-section">
        @if (type.status !== 'pending' && isAdmindata(type)) {
          <div class="admin-section">
            <div class="admin-image">
              <div class="circle"
                [ngClass]="{'green-bg': isShowrejectstatus(type), 'red-bg': !isShowrejectstatus(type)}">
                @if (isShowrejectstatus(type)) {
                  <i class="fa fa-check"></i>
                }
                @if (!isShowrejectstatus(type)) {
                  <i class="fa fa-close"></i>
                }
              </div>
            </div>
            <div class="admin-detail">
              <h1></h1>
              @if (!isShowrejectstatus(type)) {
                <h6>Rejected</h6>
              }
              @if (isShowrejectstatus(type)) {
                <h6>Approved</h6>
              }
            </div>
          </div>
        }
        @for (detail of type.leave_details; track detail) {
          <div>
            <div class="admin-main-wrraper">
              <div class="admin-section">
                <h6 class="dash">- - - - - - -</h6>
              </div>
              <div class="admin-section admin-detail-sec">
                <div class="admin-image">
                  <img
                    [src]="detail.admin.profile_image ? detail.admin.profile_image : 'assets/images/question.jpg'"
                    alt="missing">
                  </div>
                  <div class="admin-detail">
                    <h6>{{ detail.admin.first_name }} {{ detail.admin.last_name }}</h6>
                    <p class="admin-status"
                      [ngClass]="{'green-font': detail.status === 'approved', 'red-font': detail.status === 'rejected'}">
                    {{ detail.status | titlecase }}</p>
                    <p>{{ detail.action_date | date: 'yyyy-MM-dd' }}</p>
                    @if (detail.status === 'rejected') {
                      <div class="more-info" (click)="showLeaveDetail(detail)"
                        data-toggle="modal" data-target="#infoModal">
                        <i class="fa fa-info-circle"></i>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  @if (type.status==='pending') {
    <div class="inderBelow2  mt-2 mr-4">
      <button (click)="deleteDetail(type)" data-toggle="modal" data-target="#exampleModalCenter"
            class="btn btn-default deleteButton pl-3 pr-3 " [ngStyle]="{
          'color': selectedMode === 'dark' ? '#FFFFFF' : '#000000',
          'background-color': selectedMode === 'dark' ? '#111526' : ''}"> Delete</button>
      <button (click)="editLeave(type)" class="btn btn-primary deleteButton pl-4 pr-4 "> Edit</button>
    </div>
  }
</div>
}

<!-- start -->


<!--end  -->
</div>
</div>
</main>





<!-- Modal -->
<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Delete Leave</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        Are you sure you want to delete this leave?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" (click)="deleteLeave(deleteValueModal)" class="btn btn-primary">Delete</button>
      </div>
    </div>
  </div>
</div>
<!-- info modal -->

<div class="modal fade" id="infoModal" tabindex="-1" role="dialog" aria-labelledby="infoModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="infoModalLabel">Leave Detail</h5>
      </div>
      <div class="modal-body info-modal-body">
        <!-- Display current leave detail -->
        <div class="row">
          <div class="col-4">
            <strong>Admin:</strong>
          </div>
          <div class="col-8">
            <p> {{ currentLeaveDetail.admin.first_name }} {{ currentLeaveDetail.admin.last_name }}</p>
          </div>
          <div class="col-4">
            <strong>Status:</strong>
          </div>
          <div class="col-8">
            <p> {{ currentLeaveDetail.status | titlecase }}</p>
          </div>
          <div class="col-4">
            <strong>Action Date:</strong>
          </div>
          <div class="col-8">
            <p> {{ currentLeaveDetail.action_date | date: 'yyyy-MM-dd' }}</p>
          </div>
          <div class="col-4">
            <strong>Reason:</strong>
          </div>
          <div class="col-8">
            <p> {{ currentLeaveDetail.reason ? currentLeaveDetail.reason : 'No Reason for Approve' }}</p>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="leaveinfoModal" tabindex="-1" role="dialog" aria-labelledby="leaveinfoModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="leaveinfoModalLabel">Leave Count Detail</h5>
      </div>
      <div class="modal-body info-modal-body">
        <div class="row">
          <div class="col-4">
            <div class="col-head">
              Category
            </div>
          </div>
          <div class="col-4">
            <div class="col-head">
              Asigned Leaves
            </div>
          </div>
          <div class="col-4">
            <div class="col-head">
              Remaining Leaves
            </div>
          </div>
          @for (item of remainleaves; track item) {
            <div class="col-4">
              <div class="col-data">
                {{item.leave_name | titlecase}} <span class="leave_type">({{item.leave_type | titlecase }})</span>
              </div>
            </div>
            <div class="col-4">
              <div class="col-data">
                {{item.assigned_leaves}}
              </div>
            </div>
            <div class="col-4">
              <div class="col-data">
                {{item.assigned_leaves - item.leave_count}}
              </div>
            </div>
          }
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>